import SortingWidget from "js/components/widgets/SortingWidget";
import FilteringWidget from "js/components/widgets/FilteringWidget";

export default {
    components: {
        SortingWidget,
        FilteringWidget,
    },
    data() {
        return {
            list: [],
            store: undefined,
            actionsEdit: "",
        };
    },
    computed: {
        isEmpty() {
            return !this.list.length;
        },
        hasQuery() {
            return !!Object.keys(this.store?.query ?? {}).length;
        },
    },
    methods: {
        setAction(type) {
            if (this.actionsEdit === type) {
                this.actionsEdit = "";
            } else {
                this.actionsEdit = type;
            }
        },
        async updateList(key, value) {
            this.store.updateQuery(key, value);
            this.list = await this.getList();
        },
    },
};
